module.exports = "https://static.energy5.com/_next/static/images/needEmailImage-05b3e4fbd8fd04b5bc0eca0bc3bd8302.jpg";